/**
 * General reducers script file
 *
 * @package    Reducers
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
    apiHost: process.env.API_HOST,
    publicURL: process.env.PUBLIC_URL,
});

export default function generalReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        default:
            return state;
    }
}
